module.exports = __webpack_public_path__ + "static/media/sistineChapel.1280.1280.4e3e0229.png";